// extracted by mini-css-extract-plugin
module.exports = {"title":"_1kP7-Y"};